(() => {
  function getCategoriesEl() {
    return document.getElementById('collection-categories');
  }

  function scrollToCategories(behavior) {
    const el = getCategoriesEl();
    if (!el) return;
    el.scrollIntoView({ behavior });
  }

  const shopLinks = [...document.querySelectorAll('a[href*="#collection-categories"]')];

  if (shopLinks.length) {
    shopLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        if (!getCategoriesEl()) return;

        let targetUrl;
        try {
          targetUrl = new URL(link.href, window.location.origin);
        } catch {
          return;
        }

        if (targetUrl.pathname !== window.location.pathname) return;

        e.preventDefault();
        requestAnimationFrame(() => scrollToCategories('smooth'));
      });
    });
  }

  if (window.location.hash === '#collection-categories') {
    const scroll = () => scrollToCategories('auto');
    scroll();
    requestAnimationFrame(scroll);
    window.addEventListener('load', scroll, { once: true });
  }
})();

(() => {
  if (customElements.get('header-navigation')) return;

  class HeaderNavigation extends HTMLElement {
    constructor() {
      super();
      this.onToggleMenu = this.onToggleMenu.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onMobileNavClick = this.onMobileNavClick.bind(this);
      this.onOverlayTouchMove = this.onOverlayTouchMove.bind(this);
      this.onMobileSearchFocusIn = this.onMobileSearchFocusIn.bind(this);
      this.onVisualViewportChange = this.onVisualViewportChange.bind(this);
      this.scrollLocked = false;
      this.scrollY = 0;
    }

    connectedCallback() {
      this.toggleButtons = [...this.querySelectorAll('[data-action="toggle-menu"]')];
      this.mobileOverlay = this.querySelector('[data-mobile-overlay]');
      this.mobileNav = this.querySelector('.js-header__mobile-overlay-nav');
      this.mobileOverlayBody = this.querySelector('.header__mobile-overlay-body');

      if (this.toggleButtons.length && this.mobileOverlay) {
        this.mobileOverlay.setAttribute('aria-hidden', 'true');
        this.toggleButtons.forEach((btn) => btn.addEventListener('click', this.onToggleMenu));
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('touchmove', this.onOverlayTouchMove, { passive: false });
        this.mobileOverlay.addEventListener('focusin', this.onMobileSearchFocusIn);
      }

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.onVisualViewportChange);
        window.visualViewport.addEventListener('scroll', this.onVisualViewportChange);
      }

      this.mobileNav?.addEventListener('click', this.onMobileNavClick);
    }

    disconnectedCallback() {
      this.toggleButtons?.forEach((btn) => btn.removeEventListener('click', this.onToggleMenu));
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('touchmove', this.onOverlayTouchMove);
      this.mobileOverlay?.removeEventListener('focusin', this.onMobileSearchFocusIn);
      window.visualViewport?.removeEventListener('resize', this.onVisualViewportChange);
      window.visualViewport?.removeEventListener('scroll', this.onVisualViewportChange);
      this.unlockPageScroll();
      this.mobileNav?.removeEventListener('click', this.onMobileNavClick);
    }

    lockPageScroll() {
      if (this.scrollLocked) return;
      this.scrollLocked = true;
      this.scrollY = window.scrollY;
      document.documentElement.classList.add('header-scroll-lock');
      document.body.classList.add('header-scroll-lock');
      document.body.style.top = `-${this.scrollY}px`;
    }

    unlockPageScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      document.documentElement.classList.remove('header-scroll-lock');
      document.body.classList.remove('header-scroll-lock');
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY);
    }

    isMenuOpen() {
      return this.mobileOverlay?.getAttribute('aria-hidden') === 'false';
    }

    stabilizePageScroll() {
      const y = this.scrollY;
      const fix = () => {
        if (window.scrollY !== y) window.scrollTo(0, y);
      };
      fix();
      requestAnimationFrame(fix);
      window.setTimeout(fix, 50);
      window.setTimeout(fix, 150);
    }

    onMobileSearchFocusIn(event) {
      if (!this.isMenuOpen()) return;
      if (!event.target?.matches?.('.js-predictive-search-input')) return;
      this.stabilizePageScroll();
    }

    onVisualViewportChange() {
      if (!this.isMenuOpen()) return;
      this.stabilizePageScroll();
    }

    onOverlayTouchMove(event) {
      if (!this.isMenuOpen()) return;
      if (this.mobileOverlayBody?.contains(event.target)) return;
      event.preventDefault();
    }

    onToggleMenu() {
      const opening = !this.isMenuOpen();
      this.mobileOverlay.setAttribute('aria-hidden', String(!opening));
      this.toggleButtons[0]?.setAttribute('aria-expanded', String(opening));
      if (opening) {
        this.lockPageScroll();
      } else {
        this.unlockPageScroll();
      }
    }

    closeMenu() {
      if (!this.mobileOverlay) return;
      this.mobileOverlay.setAttribute('aria-hidden', 'true');
      this.toggleButtons[0]?.setAttribute('aria-expanded', 'false');
      this.unlockPageScroll();
    }

    onMobileNavClick(event) {
      const link = event.target?.closest?.('a');
      if (!link) return;
      if (this.mobileOverlay?.getAttribute('aria-hidden') !== 'false') return;
      this.closeMenu();
    }

    onKeyDown(event) {
      if (event.key !== 'Escape') return;
      if (this.mobileOverlay?.getAttribute('aria-hidden') === 'false') {
        this.onToggleMenu();
      }
    }
  }

  customElements.define('header-navigation', HeaderNavigation);
})();
